"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var document_search_config_1 = require("../model/document-search.config");
var document_search_configs_provider_1 = require("./document-search-configs.provider");
var category_relation_config_1 = require("../../component/model/config/category-relation-config");
var additional_filter_config_1 = require("../../component/model/config/additional-filter-config");
var additional_action_config_1 = require("../../component/model/config/additional-action-config");
var root_category_provider_service_1 = require("../../../../../shared/services/api/root-category-provider.service");
var additional_document_meta_data_filter_config_1 = require("../../component/model/config/additional-document-meta-data-filter-config");
var ConsulDocumentSearchConfigsProvider = /** @class */ (function (_super) {
    __extends(ConsulDocumentSearchConfigsProvider, _super);
    function ConsulDocumentSearchConfigsProvider(applicationPropertiesService, rootCategoryProvider) {
        var _this = _super.call(this) || this;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.rootCategoryProvider = rootCategoryProvider;
        return _this;
    }
    ConsulDocumentSearchConfigsProvider_1 = ConsulDocumentSearchConfigsProvider;
    ConsulDocumentSearchConfigsProvider.parseAdditionalMetaDateFilterConfigs = function (additionalMetaDateFilterConfigsJson) {
        if (additionalMetaDateFilterConfigsJson && additionalMetaDateFilterConfigsJson.length) {
            return additionalMetaDateFilterConfigsJson.map(function (configs) {
                return new additional_document_meta_data_filter_config_1.AdditionalDocumentMetaDataFilterConfig(configs.metaDataFieldName, +configs.metaFieldType, configs.label, configs.showInMain);
            });
        }
        return [];
    };
    ConsulDocumentSearchConfigsProvider.parseAdditionalFilterConfigs = function (additionalFilterConfigsJson) {
        if (additionalFilterConfigsJson && additionalFilterConfigsJson.length) {
            return additionalFilterConfigsJson.map(function (configs) {
                return new additional_filter_config_1.AdditionalFilterConfig(configs.filterableCategory, configs.filterableFields);
            });
        }
        return [];
    };
    ConsulDocumentSearchConfigsProvider.parseSubEntityFilterConfigs = function (subEntityFilterConfigsJson) {
        if (subEntityFilterConfigsJson && subEntityFilterConfigsJson.length) {
            return subEntityFilterConfigsJson;
        }
        return [];
    };
    ConsulDocumentSearchConfigsProvider.parseAdditionalActionConfigs = function (additionalActionConfigsJson) {
        if (additionalActionConfigsJson && additionalActionConfigsJson.length) {
            return additionalActionConfigsJson.map(function (configs) {
                return new additional_action_config_1.AdditionalActionConfig(configs.icon, configs.className, configs.title, configs.action, configs.actionKey);
            });
        }
        return [];
    };
    ConsulDocumentSearchConfigsProvider.prototype.getConfigurations = function (rootCategoryId) {
        var _this = this;
        return this.loadConfig().pipe(operators_1.switchMap(function (documentSearchConfigs) { return _this.rootCategoryProvider.getChildCategories(rootCategoryId).pipe(operators_1.map(function (childCategories) { return _this.parseConfig(documentSearchConfigs, rootCategoryId, childCategories); })); }));
    };
    ConsulDocumentSearchConfigsProvider.prototype.loadConfig = function () {
        if (!this.documentSearchConfigs$) {
            this.documentSearchConfigs$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.loadProjectConfigs()).pipe(operators_1.map(function (value) { return value['documentSearchConfigs'] ? JSON.parse(value['documentSearchConfigs']) : undefined; }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.documentSearchConfigs$;
    };
    ConsulDocumentSearchConfigsProvider.prototype.parseConfig = function (documentSearchConfigs, category, childCategories) {
        if (documentSearchConfigs) {
            var categoryRelatedConfigs = documentSearchConfigs[category];
            var additionalFilterConfigs = ConsulDocumentSearchConfigsProvider_1
                .parseAdditionalFilterConfigs(categoryRelatedConfigs.additionalFilterConfigs);
            var additionalMetaDateFilterConfigs = ConsulDocumentSearchConfigsProvider_1
                .parseAdditionalMetaDateFilterConfigs(categoryRelatedConfigs.additionalDocumentMetaDataFilterConfigs);
            var additionalActionConfigs = ConsulDocumentSearchConfigsProvider_1
                .parseAdditionalActionConfigs(categoryRelatedConfigs.additionalActionConfigs);
            var subEntityFilterConfigs = ConsulDocumentSearchConfigsProvider_1
                .parseSubEntityFilterConfigs(categoryRelatedConfigs.subEntityFilterConfig);
            var categoryRelationConfig = new category_relation_config_1.CategoryRelationConfig(category, childCategories);
            return new document_search_config_1.DocumentSearchConfig(additionalFilterConfigs, categoryRelationConfig, additionalMetaDateFilterConfigs, additionalActionConfigs, subEntityFilterConfigs, categoryRelatedConfigs.hasPreviewOption, categoryRelatedConfigs.hasDownloadOption, categoryRelatedConfigs.sortableFields, categoryRelatedConfigs.excludedCategories, categoryRelatedConfigs.minQuerySymbols, categoryRelatedConfigs.searchDocumentsCount);
        }
        throw new Error('Document search configs not provided');
    };
    var ConsulDocumentSearchConfigsProvider_1;
    ConsulDocumentSearchConfigsProvider = ConsulDocumentSearchConfigsProvider_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            root_category_provider_service_1.RootCategoryProviderService])
    ], ConsulDocumentSearchConfigsProvider);
    return ConsulDocumentSearchConfigsProvider;
}(document_search_configs_provider_1.DocumentSearchConfigsProvider));
exports.ConsulDocumentSearchConfigsProvider = ConsulDocumentSearchConfigsProvider;
//# sourceMappingURL=consul-document-search-configs.provider.js.map